(() => {
  const anchor = document.querySelector('[data-pah-question-anchor]');
  const dialog = document.getElementById('pah-contact-page-dialog');
  if (!anchor || !dialog) return;
  const link = anchor.querySelector('a');
  const content = dialog.querySelector('.pah-contact-page-content');
  const loading = dialog.querySelector('[data-pah-contact-loading]');
  const closeButton = dialog.querySelector('.pah-contact-page-close');
  const key = 'pah-native-contact-' + dialog.dataset.productId;
  let opener;
  let loadPromise;
  const mount = () => {
    const footer = document.querySelector('.pah-journey__footer');
    if (footer && anchor.parentElement !== footer) footer.appendChild(anchor);
    else if (!footer) {
      const nativeButtons = document.querySelector('.product-details .product-form-buttons');
      if (nativeButtons && anchor.previousElementSibling !== nativeButtons) nativeButtons.after(anchor);
    }
  };
  new MutationObserver(mount).observe(document.querySelector('.product-details') || document.body, {childList:true,subtree:true});
  mount();
  const loadForm = () => {
    if (loadPromise) return loadPromise;
    loading.hidden = false;
    loadPromise = fetch(link.href, {credentials:'same-origin'})
      .then(response => {
        if (!response.ok) throw new Error('Contact page unavailable');
        return response.text();
      })
      .then(html => {
        const page = new DOMParser().parseFromString(html, 'text/html');
        const source = page.querySelector('form textarea[name="contact[body]"]')?.closest('form');
        if (!source || new URL(source.getAttribute('action'), location.origin).pathname !== '/contact') throw new Error('Contact form unavailable');
        const form = document.importNode(source, true);
        content.replaceChildren(form);
        const message = form.querySelector('textarea[name="contact[body]"]');
        const productUrl = new URL(dialog.dataset.productUrl);
        const variant = new URL(location.href).searchParams.get('variant');
        if (variant) productUrl.searchParams.set('variant',variant);
        const productDetails = '\n\n--- Product details ---\nProduct: ' + dialog.dataset.productTitle + '\nProduct URL: ' + productUrl.href;
        form.addEventListener('submit', () => {
          if (form.checkValidity()) {
            if (!message.value.includes('\n\n--- Product details ---\n')) message.value += productDetails;
            try { sessionStorage.setItem(key,String(Date.now())); } catch (_) {}
          }
        }, true);
      })
      .catch(() => {
        content.textContent = 'The contact form could not load. Please use the contact page link below.';
        loadPromise = null;
      })
      .finally(() => { loading.hidden = true; });
    return loadPromise;
  };
  const open = () => {
    opener = document.activeElement;
    if (!dialog.open) dialog.showModal();
    closeButton.focus({preventScroll:true});
  };
  link.addEventListener('click', event => {
    event.preventDefault();
    open();
    loadForm();
  });
  closeButton.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus({preventScroll:true}));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r=dialog.getBoundingClientRect();
    if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) dialog.close();
  });
  let pending = 0;
  try { pending = Number(sessionStorage.getItem(key)); } catch (_) {}
  const state = document.getElementById('pah-contact-response')?.content.querySelector('[data-contact-state]');
  if (pending && Date.now()-pending < 60*60*1000 && state?.dataset.contactState) {
    open();
    if (state.dataset.contactState === 'success') {
      content.textContent = 'Thanks for contacting us. We will get back to you as soon as possible.';
      try { sessionStorage.removeItem(key); } catch (_) {}
    } else {
      loadForm().then(() => {
        const error = document.createElement('div');
        error.className = 'contact-form__error';
        error.textContent = state.textContent;
        content.prepend(error);
      });
    }
  }
})();
